import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-dialog-info-settings',
  templateUrl: './dialog-info-settings.component.html',
  styleUrls: ['./dialog-info-settings.component.scss']
})
export class DialogInfoSettingsComponent implements AfterViewInit {
  @ViewChild('infoSettings') infoSettings: Dialog;

  data: any;

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<DialogInfoSettingsComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      icon?: string;
      bodyMessage?: string;
      breakline?: boolean;
      titulo: string;
      regras: { regra: string; descricao: string }[];
    }
  ) {
    this.data = data;
  }

  ngAfterViewInit() {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.infoSettings.maximize();
  }
}
